class CampusEditFormService {

    constructor(
        $http,
        appConfig
    ) {
        'ngInject';

        this.$http = $http;
        this.appConfig = appConfig;

        this.services = undefined;
        this.countryData = {};
    }

    /***
     * Fetches a list of all Services.
     *
     * If the services have already been fetched once, then we return the locally stored version, since they are
     * unlikely to change.
     *
     * @returns {Promise | array}
     */
    getServices() {
        if (this.services !== undefined) {
            return this. services;
        }

        const hiddenServices = [
            'EXOS Rally',
            'EXOS Transform',
            'EXOS Resilience',
            'At Risk Program',
            'EXOS ESD Technology',
            'EXOS Circuit',
            'EXOS Performance Kiosk',
            'EXOS Journey',
            'EXOS Cpro',
        ];

        return this.$http.get(`${this.appConfig.apiUrl}/services/`)
            .then((successResponse) => {
                this.services = successResponse.data.filter(
                    (service) => !hiddenServices.includes(service.name)
                );
                return this.services;
            });
    }

    /**
     * fetchCountry
     *  Called from the resolve for the Campus Edit State to preload the country data
     *
     * @param countryCode {int}
     * @returns {Promise | object}
     */
    fetchCountry(countryCode) {
        return this.$http.get(`${this.appConfig.apiUrl}/countries/${countryCode}/`)
            .then((res) => {
                this.countryData = res.data;
            });
    }

    /**
     * getState
     *  Extracts an array of state objects from the country data for the selected country
     *   in a format that will work with the typehead form elements
     *
     * @returns {Array}
     */
    getStates() {
        return Object.keys(this.countryData.states).map((key) => {
            return {
                id: key,
                name: this.countryData.states[key].name
            }
        });
    }

    /**
     * getState
     *  Extracts an array of city objects from the country data for the selected country and state
     *   in a format that will work with the typehead form elements
     *
     * @param stateId {integer}
     * @returns {Array}
     */
    getCities(stateId) {
        return Object.keys(this.countryData.states[stateId].cities).map((key) => {
            return {
                id: key,
                name: this.countryData.states[stateId].cities[key]
            }
        });
    }


    /***
     * Update the given client.
     *
     * @param campusId      the ID of the campus being updated.
     * @param data          the ID of the client being updated.
     *
     * @returns {Promise}
     */
    updateCampus(campusId, data) {
        return this.$http.patch(`${this.appConfig.apiUrl}/campuses/${campusId}/`, data);
    }

}

export default CampusEditFormService;


// WEBPACK FOOTER //
// ./app/components/client-edit/campus-edit-form/campus-edit-form-service.js